import { ExecutionMetric } from 'types';

import { createCrudApi } from './crud.api';

export const executionMetricsApi =
  createCrudApi<ExecutionMetric>('/execution-metrics');
